import { render } from "./GanttComponent.vue?vue&type=template&id=3a2451c4&scoped=true"
import script from "./GanttComponent.vue?vue&type=script&lang=js"
export * from "./GanttComponent.vue?vue&type=script&lang=js"

import "./GanttComponent.vue?vue&type=style&index=0&id=3a2451c4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a2451c4"]])

export default __exports__